import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ItineraryCard from './itinerary-card';
import { sectorWithImagesAndInfo, accommodationNights, checkAccomodationRoomType, checkAccomodationMultiRoomType } from '../../../../helpers/cyoaHelper';
import { ISOCurrencyCovert } from '../../../../helpers/locationHelper';
import PriceSummary from '../../components/price-summary';
import { PostIntinerariesAccomodation } from '../../../../actions/itineraries';
import { pluralHelper } from '../../../../helpers/stringutils';
import Toggle from 'react-toggle';

class ItineraryView extends PureComponent{

  constructor(props){
    super(props);
    this.state = {
      accommodationType: props.itineraries.accomm_global_room_type,
      totalPrice:0,
      toggleCheck:props.itineraries.accomm_global_room_type === "none" ? false : true
    }

    this.onAccommodationChange = this.onAccommodationChange.bind(this);
    this.handleToggleChange = this.handleToggleChange.bind(this);
  }

  componentDidMount(){

    const { itineraries: { accomm_total, accomm_global_room_type, grand_total } } = this.props;

    this.setState({totalPrice:parseFloat(grand_total).toFixed(2), accommodationType:accomm_total !== "0.00" ? 'default' : 'none'}, () => {
        setTimeout(()=>{ this.props.PostIntinerariesAccomodation(this.props.itineraries, true, false, true, accomm_global_room_type); }, 100);
    });

  }

  componentDidUpdate(prevProps, prevState){

    const { itineraries, itineraries: { grand_total } } = this.props;

    if(itineraries !== prevProps.itineraries){

      //calculate pricing
      let total = parseFloat(grand_total).toFixed(2);

      this.setState({totalPrice:total, accommodationType:itineraries.accomm_global_room_type });

    }

  }



 onAccommodationChange(e){

    this.setState({accommodationType:e.target.value}, ()=>{
      setTimeout(()=>{ this.props.PostIntinerariesAccomodation(this.props.itineraries, true,  false, true, this.state.accommodationType); }, 100);
    });
  }



  renderRoomRadios(status, sectors){

    // Hide radios (only show with itinerary room that have both dorm and private)
    // - Confirm booking
    // - Accomodation only has one room type
    if(status === "confirmed" || checkAccomodationRoomType(sectors)) return null;

 
    return (
      <div className="row margin-t-30">
      <div className="column small-12 medium-4 no-padding-right-medium">
        <div className="busabout-radio radio">
          <input id="dormAccommodation" name="dormAccommodation" type="radio" value="default" checked={this.state.accommodationType === 'default'} onChange={this.onAccommodationChange} />
          <label htmlFor="dormAccommodation" className="radio-label">Dorm room</label>
        </div>
      </div>
      <div className="column small-12 medium-4 no-padding-left-medium no-padding-right-medium">
        <div className="busabout-radio radio middle">
          <input id="privateAccommodation" name="privateAccommodation" type="radio" value="upgrade" checked={this.state.accommodationType === 'upgrade'}  onChange={this.onAccommodationChange} />
          <label htmlFor="privateAccommodation" className="radio-label">Private room</label>
        </div>
      </div>
      <div className="column small-12 medium-4 no-padding-left-medium">
      <div className="busabout-radio radio">
        <input id="noAccommodation" name="noAccommodation" type="radio" value="none" checked={this.state.accommodationType === 'none'} onChange={this.onAccommodationChange} />
        <label htmlFor="noAccommodation" className="radio-label">No thanks</label>
      </div>
      </div>
      </div>
    )
    
  }

  renderAccommodationToggle(status, sectors){

    const { isUpdating, itineraries: { total_paid } } = this.props;
    const { toggleCheck } = this.state;

    if(status === "confirmed" || !checkAccomodationMultiRoomType(sectors)) return null;


    return (
      <div className="margin-t-20 text-left">
      <label className={`margin-t-10 ${isUpdating ? 'toggle-updating' : ''}`} style={{display: total_paid === "0.00" ? 'block' : "none"}}>
        <Toggle defaultChecked={toggleCheck} onChange={this.handleToggleChange} />
        <span className="toggle-text">{`${toggleCheck ? 'include accommodation' : 'no accommodation'}`} </span>
      </label>
      </div> 
    )
    

  }

  handleToggleChange(){
    this.setState({toggleCheck: !this.state.toggleCheck}, () => {
      const roomType = !this.state.toggleCheck ? 'none' : 'default';
      this.props.PostIntinerariesAccomodation(this.props.itineraries, true, true, this.state.toggleCheck, roomType);
    });
  }

  render(){

    const { itineraries, itineraries:{sectors, iso_currency, trips, total_paid, status } } = this.props;
    const { totalPrice } = this.state;

    const NUM_NIGHTS = accommodationNights(sectors);

    return (
      <div className="itinerary-view">

        <div className="itinerary-view-accommodation">
          <div className="row">
            <div className="column small-12 medium-6">
              <p className="itinerary-text">Here is your full Itinerary</p>
              <p className="itinerary-subtext">View your full trip itinerary including destination stops, pick-up &amp; drop-off points, and choose accommodation for the entire trip or per destination in a shared room or a private room.</p>
            </div>
            <div className="column small-12 medium-6 itinerary-pricing">

              <div className="row margin-t-30">
                <div className="column small-12 medium-6">
                  <p className="no-margin total-text">{total_paid === "0.00" ? "Total price" : "Balance due"}</p>
                  <p className="bold orange-text price-text" style={{display: totalPrice === 0 ? 'none' : 'block'}}>
                    {ISOCurrencyCovert(iso_currency)}{totalPrice}&nbsp;
                    <span className="currency">{iso_currency}</span>
                  </p>
                  <p className="no-margin accommodation-text">includes {NUM_NIGHTS} {pluralHelper('night', NUM_NIGHTS)} of accommodation</p>
                </div>
                <div className="column small-12 medium-6">
                  <PriceSummary type="payment" buttononly={true} />
    
                  {this.renderAccommodationToggle(status, sectors)}
          
                </div>
              </div>

            </div>
          </div>

    
          {this.renderRoomRadios(status, sectors)}

        </div>


        {
          sectorWithImagesAndInfo(itineraries).map((item, i) => {

            return (
              <Fragment key={i}>
                <ItineraryCard data={item} index={i} alldata={sectors} currency={iso_currency} trips={trips} masterAccommodationType={this.state.accommodationType} total_paid={total_paid}/>
                <div className="dot-line">
                  <div className="bus-next-destination" style={{'display': item.next_transfer.icon === "bus" ? "block" : "none"}}>
                      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#3D3D3D" fillRule="nonzero">
                          <path d="M10.5 18a47.708 47.708 0 0 1-5.777-.357A1.97 1.97 0 0 1 3 15.688V4.633A4.638 4.638 0 0 1 7.632 0h5.736A4.638 4.638 0 0 1 18 4.633v11.055a1.97 1.97 0 0 1-1.723 1.955A47.707 47.707 0 0 1 10.5 18zM7.632 1.065a3.571 3.571 0 0 0-3.567 3.568v11.055c0 .455.338.84.79.898 1.873.23 3.758.347 5.645.349a46.658 46.658 0 0 0 5.645-.35.905.905 0 0 0 .79-.897V4.633a3.571 3.571 0 0 0-3.567-3.568H7.632z"/>
                          <path d="M3.533 4C3.239 4 3 3.78 3 3.508s.238-.492.532-.493L17.467 3c.294 0 .533.22.533.492s-.238.492-.532.493L3.533 4zM17.468 11H3.532C3.238 11 3 10.776 3 10.5s.238-.5.532-.5h13.936c.294 0 .532.224.532.5s-.238.5-.532.5zM7.517 20H6.484C5.664 20 5 19.46 5 18.793v-1.337c0-.128.066-.25.182-.336a.645.645 0 0 1 .428-.118l2.878.204c.29.02.512.218.512.454v1.133C9 19.46 8.336 20 7.517 20zm-1.395-2.047v.84c0 .163.162.295.362.295h1.033c.2 0 .361-.132.362-.295v-.715l-1.757-.125zM14.516 20h-1.032c-.82-.001-1.483-.711-1.484-1.587v-1.491c0-.308.217-.565.502-.597l2.879-.322a.537.537 0 0 1 .434.151.62.62 0 0 1 .185.446v1.813c0 .876-.665 1.586-1.484 1.587zm-1.395-2.538v.95c0 .215.163.388.363.388h1.032c.2 0 .362-.173.362-.387v-1.147l-1.757.196zM12.453 13H8.547C8.245 13 8 12.776 8 12.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5zM12.453 15H8.547C8.245 15 8 14.776 8 14.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5zM12.453 3H8.547C8.245 3 8 2.776 8 2.5s.245-.5.547-.5h3.906c.302 0 .547.224.547.5s-.245.5-.547.5z"/>
                          <path d="M19.433 6a.572.572 0 0 1-.566-.576 1.167 1.167 0 0 0-.432-.834c-.723-.551-1.784-.426-1.796-.424a.569.569 0 0 1-.634-.498.575.575 0 0 1 .49-.645c.06-.009 1.522-.192 2.62.645A2.33 2.33 0 0 1 20 5.424a.572.572 0 0 1-.567.576z"/>
                          <path d="M19.565 9h-.511C18.472 9 18 8.359 18 7.568V5.59c0-.326.195-.59.435-.59h1.13c.24 0 .435.264.435.59v2.82c0 .326-.195.59-.435.59zm-.696-2.82v1.388c0 .139.083.251.185.251h.077V6.181h-.262zM.567 6H.559A.569.569 0 0 1 0 5.427c.023-.691.347-1.335.884-1.758 1.099-.839 2.56-.655 2.622-.646.31.04.53.33.49.646a.569.569 0 0 1-.635.499c-.018-.003-1.076-.126-1.797.425a1.168 1.168 0 0 0-.43.84A.575.575 0 0 1 .566 6z"/>
                          <path d="M.946 9H.435C.195 9 0 8.736 0 8.41V5.59C0 5.264.195 5 .435 5h1.13c.24 0 .435.264.435.59V7.57C2 8.359 1.528 8.999.946 9zM.87 7.82h.077c.102 0 .185-.113.185-.252V6.181H.869v1.638zM5.598 15H3.595C3.266 15 3 14.774 3 14.495v-1.99c0-.279.266-.505.595-.505h2.003C6.372 12 7 12.533 7 13.19v.62C7 14.467 6.372 15 5.598 15zM4.19 13.99h1.408c.117 0 .212-.08.212-.18v-.62c0-.1-.095-.18-.212-.18H4.19v.98zM17.405 15h-2.003C14.628 15 14 14.467 14 13.81v-.62c0-.657.628-1.19 1.402-1.19h2.003c.329 0 .595.226.595.505v1.99a.47.47 0 0 1-.174.357.652.652 0 0 1-.42.148zm-2.003-1.99c-.117 0-.212.08-.212.18v.62c0 .1.095.18.212.18h1.408v-.98h-1.408zM13.596 9a.594.594 0 1 1-.005-1.186l1.222-.012v-1.21a.593.593 0 0 1 1.187 0V8.39c0 .325-.262.59-.588.593L13.602 9h-.006z"/>
                        </g>
                      </svg>
                      <div className="bus-next-destination-text">
                      <p className="bold">{item.next_transfer.text} </p>
                      <p className="subtitle">{item.next_transfer.sub_text}</p>
                      </div>
                  </div>

                  <div className="walk-next-destination" style={{'display': item.next_transfer.icon === "walk" ? "block" : "none"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M305.5 247.3l-19.6-21.1-8.7-28.5c-7.9-26.1-23.3-47.8-43.2-62.8 19.3-13.4 32-35.7 32-60.9 0-40.8-33.2-74-74-74s-74 33.2-74 74c0 15.7 4.9 30.3 13.3 42.3-14.7 3.8-28.4 9.8-45.3 17.4l-8.6 3.8c-24 10.5-43.4 30.1-54.9 55.2l-11.8 28c-7.3 17.2-5.7 35.7 4.2 50.7C24.6 286 41.2 295 58.4 295c12.5 0 24-4.7 32.9-12.9.2 1.4.4 2.7.6 4.1l-14.2 38.9-16.3 44.6L14 422.1c-18.7 20.4-18.7 52.4 0 72.9 9.6 10.5 23.2 16.6 37.2 16.6 14 0 27.6-6 37.2-16.6l46.7-51.2c9.6-10.6 17-22.9 22-36.5l8.7-23.9 10.6 10.7c.5.5.8 1.3.9 1.9l15.6 74.2C198 494.5 219 512 242.8 512c4 0 8.1-.5 12.1-1.5 27.4-6.9 44-34.6 38-62.9l-15.6-74.1c-2.8-13.2-7.8-25.6-14.7-36.7 1.8.2 3.6.3 5.5.3 20.3 0 38.9-12.6 47.4-32.2 8.6-19.5 4.7-41.6-10-57.6zM192 32c23.2 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.8-42 42-42zm-65 364.3c-3.5 9.7-8.8 18.4-15.6 25.9l-46.7 51.2c-3.7 4.1-8.6 6.2-13.6 6.2-4.9 0-9.8-2.1-13.6-6.2-7.5-8.2-7.5-21.5 0-29.7l46.7-51.2c3.1-3.4 5.5-7.4 7.1-11.8l16.3-44.6.1.1 1 1.2 29 29.3-10.7 29.6zm141.1-91.1c-4.4 0-9-1.8-13-6.2l-23.5-25.3c-5-5.4-8.8-12.1-11-19.4-11.4-37.5-11.5-39.9-17.5-48.5l-20.9 91.7 43 43.4c10.4 10.6 17.7 24.2 20.8 39.3l15.6 74.1c2.4 11.3-4 22.6-14.4 25.2-1.5.4-3 .5-4.4.5-9.4 0-16.7-7.6-18.6-16.3l-15.6-74.2c-1.4-6.9-4.7-13-9.5-17.8L136 307.8c-11.6-13.8-15.7-31.2-11.9-47.7l15.8-69.3c-9 3.2-18.1 7.3-35.4 15-8 3.5-14.5 10-18.3 18.4L75 250.8c-3.7 8.7-10.1 12.3-16.6 12.3-12.5 0-25.2-13.4-18.2-29.9L51.7 206c8.3-18.2 21.9-31.9 38.6-39.2 34.2-15.1 48.7-22.8 76.6-22.8 36.3 0 68.3 25.3 79.8 63l10.3 33.9c.3 1 .8 2 1.6 2.8L282 269c14.1 15.3.9 36.2-13.9 36.2z"></path></svg>
                    <div className="walk-next-destination-text">
                      <p className="bold">{item.next_transfer.text} </p>
                    </div>
                  </div>

                </div>

              </Fragment>
            )
          })
        }

      </div>
    )
  }
}



function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data,
    isUpdating:state.bookingGroup.updating
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    PostIntinerariesAccomodation
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ItineraryView);



// WEBPACK FOOTER //
// ./src/components/itinerary/details/components/itinerary-view.js